import { STATUS_LABEL, STATUS_STYLES } from "@/lib/constants";

export default function StatusBadge({ status, size = "sm" }) {
  const styles = STATUS_STYLES[status] || "bg-slate-100 text-slate-700 border-slate-200";
  const sizeCls = size === "lg" ? "text-sm px-3 py-1.5" : "text-xs px-2.5 py-1";
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center rounded-full font-semibold uppercase tracking-wide border ${styles} ${sizeCls}`}
    >
      {STATUS_LABEL[status] || status}
    </span>
  );
}
